
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play-with-us",
      function () {
        return require("private-next-pages/play-with-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play-with-us"])
      });
    }
  